export var AgentType;
(function (AgentType) {
    AgentType[AgentType["EMPEROR"] = 10] = "EMPEROR";
    AgentType[AgentType["BOSS"] = 11] = "BOSS";
    AgentType[AgentType["MANAGER"] = 12] = "MANAGER";
    AgentType[AgentType["LEADER"] = 13] = "LEADER";
    AgentType[AgentType["STAFF"] = 14] = "STAFF";
})(AgentType || (AgentType = {}));
//# sourceMappingURL=AgentType.js.map